import { useEffect, useContext } from "react";
import "./Blogs.css";
import { Datacontext } from "../context/Datacontext";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const Blogs = () => {
  const { blogs, refetch, loading } = useContext(Datacontext);
  const navigate = useNavigate();

  useEffect(() => {
    if (refetch) refetch();
  }, [refetch]);

  const handleReadMore = (blog) => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    // Fire-and-forget view tracking
    fetch(`${backendUrl}/api/blogs/${blog.id}/view`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }).catch(() => {});

    if (blog.link) {
      window.open(blog.link, "_blank", "noopener,noreferrer");
    } else {
      navigate(`/blogs/${blog.id}`);
    }
  };

  // 🔄 LOADER
  if (loading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
        <Spinner animation="border" variant="primary" style={{ width: "2rem", height: "2rem" }} />
        <h5 className="mt-4 text-muted">Loading blogs...</h5>
      </div>
    );
  }

  if (!Array.isArray(blogs) || blogs.length === 0) {
    return <p className="empty-msg">No blogs available</p>;
  }

  return (
    <div className="blogs-container">
      <div className="blogs-header">
        <h1 className="page-title">Blogs</h1>
        <p className="subtitle">
          Read expert articles on health, lifestyle and wellness
        </p>
      </div>

      <div className="blogs-grid-home">
         {blogs
  .filter((blog) => blog.is_published === 1)
  .map((blog) => (
          <div className="blog-card-home" key={blog.id}>
            <div className="blog-image-wrapper">
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}${blog.cover_image}`}
                alt={blog.title}
                className="blog-thumb"
              />
            </div>

            <div className="blog-info">
              <h2 className="blog-title">{blog.title}</h2>
              <p className="blog-desc">{blog.category}</p>

              <div className="blog-meta">
                <span className="blog-date">
                  {blog.created_at &&
                    format(new Date(blog.created_at), "dd MMM yyyy")}
                </span>
              </div>

              <button
                className="read-more"
                onClick={() => handleReadMore(blog)}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
